import { sendLogToApi } from 'features/logging/sendLogToApi';

type LogOptions = Parameters<typeof sendLogToApi>[0];

export const logInfo = (message: LogOptions['errorOrMessage'], context?: LogOptions['context']) =>
  sendLogToApi({ errorOrMessage: message, context, severity: 'INFO' });

// @ts-expect-error - Expose logInfo to the window object for debugging purposes
window.logInfo = logInfo;
